import Keycloak from "keycloak-js";
import LocalStorageService from "./services/LocalStorageService";
import { toast } from "react-toastify";
import { isStaticPage } from "@selectors/index";
import config from "./config";
const _kc = new Keycloak({
  url: config.keycloakServerUrl,
  realm: "goodshape-central",
  clientId: config.keycloakClient,
});

const initKeycloak = onAuthenticatedCallback => {
  _kc
    .init({
      onLoad: "check-sso",
      silentCheckSsoRedirectUri: window.location.origin + "/silent-check-sso.html",
    })
    .then(authenticated => {
      if (authenticated || isStaticPage()) {
        onAuthenticatedCallback();
      } else {
        doLogin();
      }
    })
    .catch(e => {
      console.error("Initialize fail", e);
      location.reload();
    });
};

const doLogin = () => {
  LocalStorageService.clearToken();
  _kc.login();
};

const doLogout = () => {
  LocalStorageService.clearToken();
  _kc.logout();
};

const getToken = () => _kc.token;

const isLoggedIn = () => !!_kc.token;

const updateToken = (successCallback, failCallback = null) =>
  _kc
    .updateToken()
    .then(successCallback)
    .catch(() => {
      toast.warning("Your session has timed out and you are being returned to the login screen.");
      setTimeout(doLogin, 5000);
    });

const getUsername = () => (_kc.tokenParsed ? _kc.tokenParsed.preferred_username : "");

const keycloak = {
  initKeycloak,
  doLogin,
  doLogout,
  isLoggedIn,
  getToken,
  updateToken,
  getUsername,
  getInstance: () => _kc,
};

export default keycloak;
